<template>
  <div class="index_warp" v-loading="loading">

    <Header :currentTab="0" :isScroll="isScroll"></Header>

    <div class="screen-outer active">
      <div class="banner_top"></div>

      <div class="banner">
        <el-image style="width: 214px; height: auto;" :src="require('../../assets/image/module1.png')"></el-image>
      </div>

      <div class="module_1">
        <div class="item1 cspt" @click="gotoCate('自我认知')">
          <div class="image_box">
            <el-image style="width: 372px; height: auto;" :src="require('../../assets/image/person1.png')"></el-image>
          </div>
          <div class="text_1">自我认知</div>
          <div class="text_2">Self-Awareness</div>
        </div>
        <div class="right">
          <div class="item2 cspt" @click="gotoCate('人际交往')">
            <div class="image_box">
              <el-image style="width: 160px; height: auto;" :src="require('../../assets/image/person2.png')"></el-image>
            </div>
            <div class="text_1">人际交往</div>
            <div class="text_2">Interpersonal Communication</div>
          </div>
          <div class="bottom">
            <div class="item3 cspt" @click="gotoCate('恋爱情感')">
              <div class="image_box">
                <el-image style="width: 148px; height: auto;"
                          :src="require('../../assets/image/person3.png')"></el-image>
              </div>
              <div class="text_1">恋爱情感</div>
            </div>
            <div class="item4 cspt" @click="gotoCate('家庭关系')">
              <div class="image_box">
                <el-image style="width: 192px; height: auto;"
                          :src="require('../../assets/image/person4.png')"></el-image>
              </div>
              <div class="text_1">家庭关系</div>
            </div>
          </div>
        </div>

        <div class="all_btn cspt" @click="gotoCategory()">
          <el-image style="width: 50px; height: auto;" :src="require('../../assets/image/all.png')"></el-image>
          <div class="all">查看全部</div>
        </div>
      </div>

      <div class="module_2">
        <div class="banner">
          <el-image style="width: 214px; height: auto;" :src="require('../../assets/image/module2.png')"></el-image>
        </div>

        <div class="image_box">
          <el-image style="width: 410px; height: auto;" :src="require('../../assets/image/module_2.png')"></el-image>
        </div>

        <div class="image_box_1">
          <el-image style="width: 410px; height: auto;" :src="require('../../assets/image/module_3.png')"></el-image>
        </div>

        <div class="box">
          <div style="margin-left: 50px;" v-for="(notice,index) in noticeList" :key="notice.noticeId"
               :class="setPos(index)"
               @click="gotoDetail(notice.noticeId)">
            <div class="text_box">
              <div class="image_box">
                <!--                <el-image style="width: 226px; height: auto;"-->
                <!--                          :src="require('../../assets/image/module_2_'+(index+1)+'.png')"></el-image>-->
                <el-image style="width: 226px;height: 226px;border-radius: 50%"
                          :src="baseUrl+notice.imgPath"></el-image>
              </div>
              <div class="text_1">{{ notice.noticeTitle }}</div>
              <div class="text_2">{{ removeHtmlTags(notice.noticeContent).substr(0, 25) + '...' }}</div>
            </div>
          </div>
        </div>

        <div class="all_btn cspt" @click="gotoArticle()">查看全部</div>
      </div>

      <div class="module_3">
        <div class="banner">
          <el-image style="width: 214px; height: auto;" :src="require('../../assets/image/module3.png')"></el-image>
        </div>

        <div style="margin-top: 40px;cursor: pointer">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(activity, index) in activityList" :key="index"
            >
              <div class="banner-inner">
                <div class="banner-inner-box" v-if="activity.activityType === 1"
                     @click="gotoActivityDetail(activity.activityId)">
                  <img style="width: 100%; height: auto;"
                       :src="activity.imgpath?baseUrl+ activity.imgpath :require('../../assets/image/group1.png')"/>
                </div>
                <div class="banner-inner-box" v-else>
                  <!-- 当 activityType 不是 1 时，显示视频 -->
                  <video controls style="width: 100%; height: auto;" controlslist="nodownload"
                         @click="toggleFullScreen(activity)" ref="videoRef">
                    <source
                        :src="activity.imgpath?baseUrl+ activity.imgpath :require('../../assets/image/group1.png')"
                        type="video/mp4">
                    您的浏览器不支持 video 标签。
                  </video>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>

        <div class="all_btn cspt" @click="gotoActivity()">查看全部</div>

      </div>

      <div class="footer_img_box">
        <el-image style="width: 100%; height: auto;" :src="require('../../assets/image/footer_mask.png')"></el-image>
      </div>
    </div>

    <Sidebar></Sidebar>

    <Footer></Footer>
  </div>
</template>

<script>
import Sidebar from "@/components/sidebar/sidebar.vue"
import Footer from "@/components/footer/footer.vue"
import Header from "@/components/header/header.vue"

import {getActivityListIndex, getArticleListIndex} from "@/api/index.js"
import {iplogin} from "@/api/login";
import {getItemWithExpiry, setItemWithExpiry} from "@/store/localstoragewithexpire";
import {removeHtmlTags} from "@/utils/common";

export default {
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  components: {
    Footer,
    Sidebar,
    Header
  },
  created() {
    this.baseUrl = process.env.VUE_APP_BASE_API
    // 页面初始化函数
    this.init()
  },
  computed: {},
  data() {
    return {
      isScroll: false,
      loading: false,
      input: "",
      noticeList: [],
      baseUrl: '',
      activityList: [],
      swiperOption: {
        spaceBetween: 40, // 图片之间的间距
        centeredSlides: true, // 居中还是从图1开始
        slidesPerView: 2, // 一屏幕显示几个? 数字或者默认  auto 自动。
        notNextTick: true, // true:加载后允许触发事件 false:加载后不可以触发事件
        loop: true, // 循环吗
        initialSlide: 0,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false
        // },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          prevEl: '.swiper-button-prev', // 左侧按钮
          nextEl: '.swiper-button-next' // 右侧按钮
        },
        watchSlidesProgress: true, // 开启这个参数来计算每个slide的progress
        watchSlidesVisibility: true  // 先要开启watchSlidesProgress参数，如果开启watchSlidesVisibility，则会在每个slide增加一个指示该slide的progress值得classname
      }
    }
  },
  methods: {
    init() {
      this.getNotice();
      this.getActivity();
      //判断是否执行过ip地址登录
//      let isIpLogin = localStorage.getItem("iploginsucc");
      let isIpLogin = getItemWithExpiry("iploginsucc");
      //判断是否是跟人用户已登录
      //let isPersonLogin = localStorage.getItem('isPersonLogin');
      let isPersonLogin = getItemWithExpiry('isPersonLogin')
      //没有进行过Ip地址登录并且，没有进行过个人登录
      if ((isIpLogin == null || isIpLogin == '') && isPersonLogin != 1) {
        iplogin().then(res => {
          if (res != null && res != '') {
            let iploginsucc = res.iploginsucc;
            if (iploginsucc === 1) {
              //localStorage.setItem("isLogin", 1);
              setItemWithExpiry("isLogin", 1)
              //当使用ip地址登录成功时，后端生成uuid用于鉴别该用户，当用户退出时，根据此uuid清空redis信息
              let uuid = res.user.token.split(":")[1];
              // localStorage.setItem("uuid", uuid);
              // localStorage.setItem("token", res.token);
              // localStorage.setItem("iploginsucc", iploginsucc);
              setItemWithExpiry("uuid", uuid);
              setItemWithExpiry("token", res.token);
              setItemWithExpiry("iploginsucc", iploginsucc);
              sessionStorage.setItem("user", JSON.stringify(res.user))
              window.location.reload();
            }
          }
        });
      }
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 300);

    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 70) {
        this.isScroll = true
      } else {
        this.isScroll = false
      }
    },
    getNotice() {
      let data = {
        pageNum: 1,
        pageSize: 3,
      };
      getArticleListIndex(data).then(res => {
        this.noticeList = res.records;
      })
    },
    getActivity() {
      let data = {
        pageNum: 1,
        pageSize: 3,
      };
      getActivityListIndex(data).then(res => {
        this.activityList = res.records;
      })
    },
    removeHtmlTags(input) {
      return removeHtmlTags(input);
    },
    gotoDetail(noticeId) {
      this.$router.push('/article/detail?noticeId=' + noticeId)
    },
    gotoArticle() {
      this.$router.push('/article')
    },
    gotoPersonal() {
      this.$router.push('/personal')
    },
    gotoCategory() {
      this.$router.push('/category')
    },
    gotoActivity() {
      this.$router.push('/activity');
    },
    gotoActivityDetail(activityId) {
      this.$router.push('/activity/detail?activityId=' + activityId)
    },
    gotoCate(id_) {
      this.$router.push('/category?cateId=' + id_);
    },
    setPos(index) {
      if (index % 2 == 0) {
        return 'item cspt';
      } else {
        return 'item cspt right';
      }
    },
    toggleFullScreen(activity) {
      const video = this.$refs.videoRef;
      if (!document.fullscreenElement && video.requestFullscreen) {
        video.requestFullscreen().catch(err => {
          console.error("Error attempting to enable full-screen mode: " + err.message);
        });
        this.currentFullscreenElement = video;
      } else if (document.exitFullscreen && this.currentFullscreenElement === video) {
        document.exitFullscreen().catch(err => {
          console.error("Error attempting to exit full-screen mode: " + err.message);
        });
        this.currentFullscreenElement = null;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .swiper-pagination {
  margin: 0 auto;
  left: 50%;
  margin-left: -96px;

  .swiper-pagination-bullet {
    width: 28px;
    height: 8px;
    border-radius: 4px;
    background: #FFFFFF;
    margin-right: 4px;
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: #B46BB4;
  }
}

.swiper-button-prev {
  display: inline-block;
  width: 72px;
  height: 72px;
  background: url("../../assets/image/icon-4.png") no-repeat center/100%;
  transform: rotate(180deg);
  left: 404px;
}

.swiper-button-prev::after {
  content: none;
}

.swiper-button-next {
  display: inline-block;
  width: 72px;
  height: 72px;
  background: url("../../assets/image/icon-4.png") no-repeat center/100%;
  right: 404px;
}

.swiper-button-next::after {
  content: none;
}

.footer_img_box {
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: url("../../assets/image/footer_img.jpg") no-repeat bottom/100%;
}

.module_3 {
  position: relative;
  padding-top: 50px;

  .all_btn {
    font-size: 24px;
    color: #fff;
    background: linear-gradient(180deg, #FB5DFB 0%, #CE67CE 100%);
    width: 144px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    border-radius: 10px;
    margin: 48px auto 0;

    &:hover {
      background: linear-gradient(180deg, #CE67CE 0%, #FB5DFB 100%);
    }
  }
}

::v-deep .swiper-wrapper {
  align-items: center;
}

.swiper-slide {
  width: 870px;
  height: 516px;
  transition: 0.5s;
}

.swiper-container .swiper-wrapper .swiper-slide-prev {
  // width: 652px;
  height: 384px;
  transition: 0.5s;
  // transform: scale(0.68);
}

.swiper-container .swiper-wrapper .swiper-slide-next {
  // width: 652px;
  height: 384px;
  transition: 0.5s;
  // transform: scale(0.68);
}

.banner-inner {
  // background: #ff00ff;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}

.medium {
  // background: #ff00ff;
  width: 870px;
  padding: 0 45px;
  box-sizing: border-box;
  height: 516px;

  .item {
    width: 100%;
    height: 100%;
    background: #00ff00;
  }
}

.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .item {
    position: relative;
    margin-top: 84px;
    height: 152px;

    .image_box {
      position: absolute;
      top: -38px;
      left: -138px;
    }

    .text_box {
      position: relative;
      width: 620px;
      height: 152px;
      border-radius: 20px;
      padding: 16px 16px 0 104px;
      background: #fff;
      box-sizing: border-box;

      &:hover {
        box-shadow: 0 0 15px 0 #d9d9d9;
        margin-top: -4px;
      }

      .text_1 {
        font-size: 26px;
        color: #B46BB4;
        font-weight: 700;
        // margin-top: 16px;
      }

      .text_2 {
        margin-top: 10px;
        font-size: 22px;
        color: #B46BB4;
      }
    }
  }

  .item.right {
    .image_box {
      top: -38px;
      right: -138px;
      left: auto;
    }

    .text_box {
      padding: 16px 104px 0 16px;
    }
  }
}

.screen-outer {
  overflow: hidden;
  // background: linear-gradient(180deg, #FFFFFF 0%, #F1E5FD 100%);
}

.screen-outer.active {
  background: linear-gradient(180deg, #FFFFFF 0%, #F1E5FD 100%);
}

.module_2 {
  margin-top: 92px;
  background: #EEDEFC;
  padding: 50px 0 30px;
  position: relative;

  .image_box {
    position: absolute;
    top: -144px;
    left: -97px;
  }

  .image_box_1 {
    position: absolute;
    bottom: -222px;
    right: -108px;
  }

  .all_btn {
    font-size: 24px;
    color: #fff;
    background: linear-gradient(180deg, #FB5DFB 0%, #CE67CE 100%);
    width: 144px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    border-radius: 10px;
    margin: 48px auto 0;

    &:hover {
      background: linear-gradient(180deg, #CE67CE 0%, #FB5DFB 100%);
    }
  }
}

.module_1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 1026px;
  margin: 40px auto 0;
  position: relative;

  .item1 {
    width: 503px;
    height: 606px;
    background: linear-gradient(135deg, #B46AB4 0%, #FF5BFF 100%);
    border-radius: 16px;
    position: relative;

    &:hover {
      background: #FF5BFF;
    }

    .image_box {
      position: absolute;
      bottom: -5px;
      left: 74px;
    }

    .text_1 {
      position: absolute;
      top: 25px;
      left: 30px;
      font-size: 38px;
      color: #fff;
      font-weight: 700;
    }

    .text_2 {
      position: absolute;
      top: 85px;
      left: 30px;
      font-size: 22px;
      color: #fff;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 503px;

    .item2 {
      width: 503px;
      height: 293px;
      background: linear-gradient(180deg, #F6687E 0%, #F5986C 100%);
      border-radius: 16px;
      position: relative;

      &:hover {
        background: #F5986C;
      }

      .image_box {
        position: absolute;
        bottom: -4px;
        right: 58px;
      }

      .text_1 {
        position: absolute;
        top: 25px;
        left: 25px;
        font-size: 38px;
        color: #fff;
        font-weight: 700;
      }

      .text_2 {
        position: absolute;
        width: 173px;
        top: 85px;
        left: 25px;
        font-size: 22px;
        color: #fff;
      }
    }

    .bottom {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .item3 {
        width: 241px;
        height: 291px;
        background: linear-gradient(180deg, #78AFF0 0%, #388AEA 100%);
        border-radius: 16px;
        position: relative;

        &:hover {
          background: #388AEA;
        }

        .image_box {
          position: absolute;
          bottom: -4px;
          right: 12px;
        }

        .text_1 {
          position: absolute;
          bottom: 18px;
          left: 18px;
          font-size: 30px;
          color: #fff;
        }
      }

      .item4 {
        width: 241px;
        height: 291px;
        background: linear-gradient(180deg, #FFA0BB 0%, #FEDDC9 100%);
        border-radius: 16px;
        position: relative;

        &:hover {
          background: #FFA0BB;
        }

        .image_box {
          position: absolute;
          bottom: -4px;
          right: 12px;
        }

        .text_1 {
          position: absolute;
          top: 16px;
          left: 16px;
          font-size: 30px;
          color: #fff;
        }
      }
    }
  }

  .all_btn {
    position: absolute;
    bottom: -82px;
    right: -82px;
    width: 188px;
    height: 188px;
    border-radius: 50%;
    background: linear-gradient(318deg, #C967C9 0%, #FD5CFD 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:hover {
      background: #FD5CFD;
    }

    .all {
      font-size: 24px;
      color: #fff;
      margin-top: 22px;
    }
  }
}

.banner_top {
  height: 700px;
  background: url("../../assets/image/banner.png") no-repeat center;
  background-size: auto 100%;
}

.banner {
  margin: 0 auto;
  text-align: center;
}

::v-deep .el-select .el-input {
  width: 200px;
}

::v-deep .el-input-group__append {
  padding: 0;
  overflow: hidden;
  // border: 2px solid #3382f5;
  border: 0;
  background: linear-gradient(90deg, #AF67B3 0%, #F796B6 100%);
  border-radius: 60px 60px 60px 60px;
  font-size: 20px;
}

::v-deep .el-input-group__append .el-select {
  margin: -10px 0;
}

::v-deep .el-input-group__append .el-button {
  margin: -10px 0;

  border: none;
  color: #fff;
  border-radius: 0;
}
</style>
